import _range from "lodash/range";

import { Row } from "../lib";
import { ButtonStar } from "./button-star";

const VALUES = _range(1, 6);

type Props = {
  onChange: (newValue: number) => void;
  value: number;
};

export function Rater({ onChange, value }: Props) {
  return (
    <Row.L>
      {VALUES.map((val) => (
        <ButtonStar
          key={`star-${val}`}
          value={val}
          active={val <= value}
          onPress={onChange}
        />
      ))}
    </Row.L>
  );
}
